export const SUGGEST_GET_START = 'cars/suggest/suggestGetStart';
export const SUGGEST_GET_SUCCESS = 'cars/suggest/suggestGetSuccess';
export const SUGGEST_GET_FAIL = 'cars/suggest/suggestGetFail';
export const RESET_SELECTED_POINT = 'cars/suggest/resetSelectedPoint';
export const SELECT_POINT = 'cars/suggest/selectPoint';
export const RESET_ALL_POINTS = 'cars/suggest/resetAllPoints';
export const ACTUAL_DIRECTION_VALUE = 'cars/suggest/actualDirectionValue';
